import React from "react";
import { useNavigate } from "react-router-dom";

interface ExamCompletedPanelProps {
  examType?: string;
}

const ConfettiBG = () => (
  <div className="fixed inset-0 z-0 pointer-events-none">
    {/* 간단한 confetti 효과 (임시, 실제 confetti 라이브러리로 대체 가능) */}
    <svg width="100%" height="100%" className="absolute inset-0">
      {[...Array(80)].map((_, i) => (
        <circle
          key={i}
          cx={Math.random() * 100 + "%"}
          cy={Math.random() * 100 + "%"}
          r={Math.random() * 2 + 1}
          fill={["#FFD700", "#FF69B4", "#00E5FF", "#FFB347", "#B39DDB"][i % 5]}
          opacity={0.7}
        />
      ))}
    </svg>
  </div>
);

const ExamCompletedPanel: React.FC<ExamCompletedPanelProps> = ({ examType = "SAT" }) => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/my_exams");
  };

  return (
    <div className="min-h-screen bg-[#232c5b] flex flex-col items-center justify-start relative overflow-hidden">
      <ConfettiBG />
      <h1 className="text-white text-3xl font-bold mt-12 mb-8 z-10 text-center">
        You're All Finished!
      </h1>
      <div className="bg-white rounded-xl shadow-lg px-10 py-12 flex flex-col md:flex-row items-center max-w-2xl w-full mx-auto z-10">
        {/* 아이콘 */}
        <div className="flex-shrink-0 mb-6 md:mb-0 md:mr-8">
          <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
            <rect
              x="20"
              y="30"
              width="80"
              height="60"
              rx="8"
              fill="#E6EDF8"
              stroke="#3451d6"
              strokeWidth="3"
            />
            <rect
              x="30"
              y="40"
              width="60"
              height="40"
              rx="4"
              fill="#fff"
              stroke="#3451d6"
              strokeWidth="2"
            />
            <ellipse
              cx="60"
              cy="60"
              rx="16"
              ry="14"
              fill="#E6EDF8"
              stroke="#3451d6"
              strokeWidth="2"
            />
            <circle cx="54" cy="58" r="2" fill="#3451d6" />
            <circle cx="66" cy="58" r="2" fill="#3451d6" />
            <path
              d="M54 66c2 2 8 2 12 0"
              stroke="#3451d6"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <rect
              x="40"
              y="85"
              width="40"
              height="6"
              rx="3"
              fill="#3451d6"
              opacity="0.1"
            />
          </svg>
        </div>
        {/* 메시지 */}
        <div className="flex-1 text-center md:text-left">
          <div className="text-lg text-gray-800 mb-2">
            Congratulations on completing an {examType} test!
          </div>
        </div>
      </div>
      <div className="flex flex-col items-center gap-4 mt-8 z-10">
        <button
          className="bg-yellow-400 hover:bg-yellow-300 text-black font-bold rounded-full px-8 py-3 text-base shadow transition-colors cursor-pointer"
          onClick={handleGoHome}
        >
          Go to Home
        </button>
      </div>
    </div>
  );
};

export default ExamCompletedPanel;
